
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { format, utcToZonedTime } from 'date-fns-tz';
import { timeZoneDefault } from '@/utils/PortalConstants';
import { User } from '@/models/main';
import { isValid } from 'date-fns';
import * as routeNames from '@/router/routeNames';

@Component({
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class DatePicker extends Vue {
  private user!: User;
  public datePickerOpen = false;
  public date = '';
  public today = '';

  public dateChanged(): void {
    this.datePickerOpen = false;
    this.$emit('changeDate', this.date);
  }

  private mounted(): void {
    if (
      this.$route.name === routeNames.SCHEDULER_SHIFTS &&
      this.$route.params.date &&
      isValid(new Date(this.$route.params?.date))
    ) {
      this.date = this.$route.params.date;
    } else {
      const userTimeZone = this.user.timezone || timeZoneDefault;
      this.date = format(utcToZonedTime(new Date(), userTimeZone), 'yyyy-MM-dd');
      this.today = this.date;
    }
  }
}
